import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withMemo as _withMemo, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/logo.svg'
import _imports_1 from '@/assets/search.svg'
import _imports_2 from '@/assets/cart.svg'


const _hoisted_1 = { class: "navigation w-100" }
const _hoisted_2 = { class: "d-flex a-i-center j-i-start navigation-wrapper pl-2 pr-2" }
const _hoisted_3 = { class: "d-flex a-i-center j-content-start navigation-link w-100" }
const _hoisted_4 = { class: "logo logo-header d-flex a-i-start j-content-center mr-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "logo"
}, null, -1)
const _hoisted_6 = { class: "d-flex search-header-mobile display-flex-media-480" }
const _hoisted_7 = { class: "m-1 pointer" }
const _hoisted_8 = {
  key: 0,
  class: "w-100 d-flex j-content-end a-i-center display-none-media-1000 text-raleway-20"
}
const _hoisted_9 = { class: "d-flex cart-count-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "search"
}, null, -1)
const _hoisted_11 = { class: "cart-count text-motserrat-8-bold d-flex a-i-center j-content-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3 ml-3 navigation-delimeter" }, null, -1)
const _hoisted_13 = { class: "j-content-center mr-2" }
const _hoisted_14 = { class: "user-name-navigation text-nowrap" }
const _hoisted_15 = { class: "img-navigation d-flex a-i-center j-content-center" }
const _hoisted_16 = { class: "img-navigation d-flex a-i-center j-content-center hidden" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "user-type-wrapper d-flex a-i-center" }
const _hoisted_19 = { class: "text-motserrat-8-light ml-2 firm_status pr-1 pl-1" }
const _hoisted_20 = { class: "link-mobile-menu" }
const _hoisted_21 = { class: "link-mobile-menu" }
const _hoisted_22 = { class: "link-mobile-menu" }
const _hoisted_23 = { class: "mb-5 pb-4 d-flex direction-column a-i-start" }

import { changeComponentAuthorization } from "@/utils/component/component";
import { logoutUser } from "@/utils/logout/logoutUser";
import { IStore } from "@/store/types/StoreType";
import { useStore } from "vuex";

import { UserTypeOperation } from "@/store/modules/User/type";
import { Locations } from "@/store/modules/Locations/type";
import { RouterLink, useRoute } from "vue-router";
import { computed, ref, watch } from "vue";
import { i18n } from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationComponent',
  setup(__props) {

const open = ref(false);
const store = useStore<IStore>();

// const userType = ref(computed<string[]>(() => store.getters.getUserType))

const route = useRoute();
const currentRouteName = computed(() => route.name);
const language = ref(store.state.LanguageTypeOperation.language);
const token = ref(computed<string>(() => store.getters.accessTokenGet));
const tokenLoading = ref(computed<boolean>(() => store.getters.loadingGet));
const userLanguage = ref(computed<string>(() => store.getters.getUserUiLang));
const userLoading = ref(computed<boolean>(() => store.getters.getUserLoading));
const userData = ref(
  computed<UserTypeOperation>(() => store.getters.getUserData)
);
const locationLoading = ref(
  computed<boolean>(() => store.getters.getCustomerLocationLoading)
);
const locationCustomer = ref(
  computed<Locations[]>(() => store.getters.getLocationsCustomerById)
);

const userCustomerType = ref(
  computed<string | null>(() => store.getters.getUserCustomerTypeData)
);

const updateLanguage = (event: EventTarget | null) => {
  if (!event) return;
  const element = event as HTMLInputElement;

  const lang = element.value;

  if (!lang) return;

  store.dispatch("updateLanguage", lang);
};

watch(
  () => userLanguage.value,
  () => {
    i18n.global.locale = userLanguage.value;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(RouterLink), { to: { name: 'start' } }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(RouterLink), {
            class: "link t-dark display-none-media-480 link-pc",
            to: { name: 'new_orders' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), {
            class: "link t-dark display-none-media-480 link-pc",
            to: { name: 'private_policy' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("information")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), {
            class: "link t-dark display-none-media-480 link-pc",
            to: { name: 'orders' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("orders")), 1)
            ]),
            _: 1
          }),
          (token.value)
            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                key: 0,
                class: "link t-dark display-none-media-480 link-pc",
                to: { name: 'account' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tc("account")), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(RouterLink), {
                key: 1,
                class: "link t-dark display-none-media-480 link-pc",
                to: { name: 'auth' },
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeComponentAuthorization)('login_component')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$tc("account")), 1)
                ]),
                _: 1
              })),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "search",
                class: _normalizeClass({ ' display-none-media-480': open.value })
              }, null, 2)
            ]),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (open.value = !open.value)),
              class: "m-1 pointer"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["burger", { open: open.value }])
              }, null, 2)
            ])
          ], 512), [
            [_vShow, true]
          ])
        ]),
        (userData.value?.photo_path || userData.value.first_name || userData.value.last_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(RouterLink), {
                to: { name: 'cart' },
                class: "text-decoration-none text-dark d-flex"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(store).getters.getAllCountInCart > 99
                  ? `+${99}`
                  : _unref(store).getters.getAllCountInCart), 1)
                  ])
                ]),
                _: 1
              }),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString((userData.value?.first_name || ' ') + ' ' + (userData.value?.last_name || ' ')), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (userData.value.photo_path)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "img-center",
                        src: userData.value.photo_path || '',
                        alt: userData.value.photo_path || 'photo_' + userData.value.first_name
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["user-type", {
                approved:
                  (_unref(store).getters.getUserCustomerFirmStatus || '').toString() ===
                  'APPROVED',
              }])
                  }, null, 2),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(store).getters.getUserCustomerFirmStatus === "NULL"
                  ? "INACTIVE"
                  : _unref(store).getters.getUserCustomerFirmStatus || "INACTIVE"), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, 
      currentRouteName.value !== 'ordersDetailsPcr' &&
      currentRouteName.value !== 'ordersDetailsTbr' &&
      currentRouteName.value
    ]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["display-flex-media-480 background-menu-mobile", { open: open.value }]),
      onClick: [
        _cache[12] || (_cache[12] = ($event: any) => (open.value = !open.value)),
        _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
      ]
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu-mobile d-flex direction-column", { 'open-mobile-menu': open.value }])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_unref(RouterLink), {
              class: "p-1 t-white text-start text-decoration-none text-raleway-24",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (open.value = !open.value)),
              to: { name: 'private_policy' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tc("information")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_unref(RouterLink), {
              class: "p-1 t-white text-start text-decoration-none text-raleway-24",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (open.value = !open.value)),
              to: { name: 'orders' }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tc("orders")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            (token.value)
              ? (_openBlock(), _createBlock(_unref(RouterLink), {
                  key: 0,
                  class: "p-1 t-white text-start text-decoration-none text-raleway-24",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (open.value = !open.value)),
                  to: { name: 'account' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("account")), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(RouterLink), {
                  key: 1,
                  class: "p-1 t-white text-start text-decoration-none text-raleway-24",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (
              (open.value = !open.value), _unref(changeComponentAuthorization)('login_component')
            )),
                  to: { name: 'auth' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$tc("account")), 1)
                  ]),
                  _: 1
                }))
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          (token.value && token.value?.length > 0)
            ? _withMemo([token.value], () => (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "text-raleway-16 t-white p-2 mb-2",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(logoutUser) && _unref(logoutUser)(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$tc("Logout")), 1)
              ])), _cache, 7)
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
            class: "select text-raleway-16 t-white p-2 mr-5 mb-2",
            onInput: _cache[9] || (_cache[9] = ($event: any) => (updateLanguage($event.currentTarget)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(language.value, (lang) => {
              return (_openBlock(), _createElementBlock("option", {
                key: `Lang${lang}`
              }, _toDisplayString(lang), 1))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.$i18n.locale]
          ]),
          (userCustomerType.value === 'Distributor')
            ? _withMemo([userData.value, tokenLoading.value, userLoading.value], () => (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "text-raleway-16 t-white p-2 mb-2"
              }, [
                _createTextVNode(_toDisplayString(tokenLoading.value || userLoading.value
              ? "Loading..."
              : userData.value?.first_name + " " + userData.value?.last_name || ""), 1)
              ])), _cache, 10)
            : _createCommentVNode("", true),
          (userCustomerType.value === 'Distributor')
            ? _withMemo([
            userCustomerType.value,
            locationCustomer.value[0]?.geo_place_country,
            locationLoading.value,
            tokenLoading.value,
          ], () => (_openBlock(), _createElementBlock("p", {
                key: 2,
                class: "text-raleway-16 t-white p-2 mb-2"
              }, [
                _createTextVNode(_toDisplayString(locationLoading.value || tokenLoading.value
              ? "Loading..."
              : locationCustomer.value[0]?.geo_place_country), 1)
              ])), _cache, 11)
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2), [
      [_vShow, 
      currentRouteName.value !== 'ordersDetailsPcr' &&
      currentRouteName.value !== 'ordersDetailsTbr' &&
      currentRouteName.value
    ]
    ])
  ], 64))
}
}

})